module.exports = __webpack_public_path__ + "img/cbd5blur.cc299550.jpg";